/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import c from "prop-types";
import { classNames as p } from "@progress/kendo-react-common";
const t = e.forwardRef((a, o) => {
  const { id: s, className: m, style: l, children: n } = a, r = e.useRef(null);
  return e.useImperativeHandle(
    o,
    () => ({
      element: r.current
    })
  ), /* @__PURE__ */ e.createElement("div", { id: s, className: p("k-toolbar-item", m), style: l, ref: r }, n);
});
t.displayName = "KendoReactToolbarItem";
t.propTypes = {
  className: c.string
};
export {
  t as ToolbarItem
};
